mem.gameStats = function (game) {
  var stats = {
    lives: game.lives(),
    errors: game.errors(),
    time: game.time()
  };

  var errorRatio = 1 + (stats.lives / (stats.errors + 1)),
    timeBonus = (50000) / (stats.time + 1);

  stats.score = Math.ceil((2000 * errorRatio) + (2000 * timeBonus));

  return stats;
};
